import _asyncToGenerator from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/regenerator";
import managedPromise from '../../managedPromise';
import walletEvents from './wallet-events';
import eventSeverities from './severities';

var Wallet = /*#__PURE__*/function () {
  function Wallet(validChainIds) {
    _classCallCheck(this, Wallet);

    var instance = this;
    instance.activated = false;
    instance.address = '';
    instance.chainId = null;
    instance.locked = true;
    instance.name = 'no wallet';
    instance.hardwareWallet = false;
    instance._validChainIds = validChainIds;
    instance.accounts = [];
    instance.initializationPromise = managedPromise();
    instance.emitter = walletEvents;
    instance.eventSeverities = eventSeverities;
  }

  _createClass(Wallet, [{
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.deactivate();
                return _context.abrupt("return", false);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function activate() {
        return _activate.apply(this, arguments);
      }

      return activate;
    }() // CAREFULL: do NOT use `async` because that will return an native Promise-A+ object. But we need a manipulated Promise with extra features

  }, {
    key: "isInitialized",
    value: function isInitialized() {
      return this.initializationPromise;
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      var instance = this;
      instance.activated = false;
      instance.accounts = [];
      instance.address = '';
      instance.chainId = null;
      instance.locked = true;
    }
  }, {
    key: "networkConnected",
    value: function networkConnected() {
      return false;
    }
  }, {
    key: "sendTx",
    value: function () {
      var _sendTx = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function sendTx() {
        return _sendTx.apply(this, arguments);
      }

      return sendTx;
    }()
  }, {
    key: "switchToNetwork",
    value: function () {
      var _switchToNetwork = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function switchToNetwork() {
        return _switchToNetwork.apply(this, arguments);
      }

      return switchToNetwork;
    }()
  }, {
    key: "isInstalled",
    value: function () {
      var _isInstalled = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                false;

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function isInstalled() {
        return _isInstalled.apply(this, arguments);
      }

      return isInstalled;
    }()
  }, {
    key: "onUpdate",
    value: function onUpdate(cb) {
      if (typeof cb === 'function') {
        this._forceUpdateFn = cb;
      }
    }
  }, {
    key: "forceUpdateContext",
    value: function forceUpdateContext() {
      var cb = this._forceUpdateFn;

      if (typeof cb === 'function') {
        cb();
      }
    }
  }]);

  return Wallet;
}();

export default Wallet;